import { render, staticRenderFns } from "./Clover.vue?vue&type=template&id=5f7d06e9&"
import script from "./Clover.vue?vue&type=script&lang=ts&"
export * from "./Clover.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports